import styled from "styled-components";
import {
  questionTextColor,
  whiteColor,
  disabledColor,
  buttonGradient,
} from "../../../constants/colors";

const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${(props) => (props.type === "default" ? "100%" : "180px")};
  border: ${(props) =>
    props.type === "default" ? "none" : `1px solid ${questionTextColor}`};
  height: ${(props) => (props.type === "default" ? "54px" : "37px")};
  background: ${(props) => (props.type === "default" ? whiteColor : "none")};
  background: ${(props) => props.isGradient && buttonGradient};
  border-radius: 56px;
  transition: 0.3s;
  z-index: 1;
  position: relative;
  p {
    color: ${(props) => props.isGradient && whiteColor};
  }
  &.disabled {
    pointer-events: none;
    background: ${(props) =>
      props.isOpacityDisabled ? buttonGradient : "#bbbbbb"};
    transition: 0.3s;
    opacity: ${(props) => (props.isOpacityDisabled ? 0.5 : 1)};
  }
  &:focus {
    outline: none;
  }
  &:active {
    outline: none !important;
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgb(0 0 0 / 10%);
  }
  @media (max-width: 767px) {
    height: ${(props) => (props.type === "default" ? "54px" : "54px")};
  }
`;

ButtonBlock.Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 35px;
  span {
    color: white;
    font-family: "SF", sans-serif;
    font-size: 63px;
  }
`;

ButtonBlock.Wrapper = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 12px;
  }
`;

export { ButtonBlock };
